/**
 * 独立页面菜单配置
 * 动态菜单中匹配的项点击后跳转到全屏独立路由，而非后台 layout 内嵌
 */
export const DEVICE_CHECK_STANDALONE_ROUTE = '/DeviceCheck';

/**
 * 判断菜单项是否为设备质检
 * @param {Object} item 菜单项
 */
export function isDeviceCheckMenu(item) {
    if (!item) return false;
    const name = String(item.name || '').toLowerCase();
    const path = String(item.path || '').toLowerCase();
    const component = String(item.component || '').toLowerCase();
    return (
        name === 'devicecheck' ||
        path.includes('devicecheck') ||
        component.includes('devicecheck/devicecheck')
    );
}

/**
 * 获取菜单项对应的独立页面路由
 * @param {Object} item 菜单项
 */
export function getStandaloneRoute(item) {
    if (isDeviceCheckMenu(item)) {
        return DEVICE_CHECK_STANDALONE_ROUTE;
    }
    return null;
}

/**
 * 根据 path 在菜单树中查找菜单项
 * @param {Array} list 菜单列表
 * @param {string} path 路由 path
 */
export function findMenuByPath(list, path) {
    if (!list || !list.length) return null;
    for (let i = 0; i < list.length; i++) {
        const item = list[i];
        if (item.path === path) return item;
        if (item.children && item.children.length) {
            const found = findMenuByPath(item.children, path);
            if (found) return found;
        }
    }
    return null;
}

/**
 * 从动态路由注册列表中过滤独立页面菜单（保留侧边栏展示，不注册为 layout 子路由）
 * @param {Array} children 子菜单/路由列表
 */
export function filterStandaloneMenusFromRoutes(children) {
    if (!children || !children.length) return children;
    return children
        .filter(item => !isDeviceCheckMenu(item))
        .map(item => {
            if (item.children && item.children.length) {
                return { ...item, children: filterStandaloneMenusFromRoutes(item.children) };
            }
            return item;
        });
}

/**
 * 判断当前访问路径是否为旧版设备质检后台内嵌路由
 * @param {string} path 路由 path
 */
export function isLegacyDeviceCheckPath(path) {
    const normalized = String(path || '').toLowerCase();
    return normalized.includes('devicecheck') && normalized !== DEVICE_CHECK_STANDALONE_ROUTE.toLowerCase();
}
